import { IonButton, IonCard, IonCardContent, IonCol, IonGrid, IonIcon, IonInput, IonItem, IonLabel, IonRow, IonSelect, IonSelectOption, IonSkeletonText, IonText, IonTextarea, useIonAlert, useIonLoading, useIonRouter } from '@ionic/react';
import { createOutline, pencilOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Preferences } from '@capacitor/preferences';
import { useAppContext } from '../AppProvider';

const AccountContact: React.FC = () => {
    const [formValues, setFormValues] = useState({
                                                    memberFirstName: "",
                                                    memberLastName: "",
                                                    memberEmail: "",
                                                    memberPhone: "",
                                                });
    const [nameEdit, setNameEdit] = useState<boolean>(false);
    const [emailEdit, setEmailEdit] = useState<boolean>(false);
    const [phoneEdit, setPhoneEdit] = useState<boolean>(false);
    const [memberPhone, setMemberPhone] = useState<string>('');
    const [addressEdit, setAddressEdit] = useState<boolean>(false);
    const [interestsEdit, setInterestsEdit] = useState<boolean>(false);
    const [present, dismiss] = useIonLoading();  
    const [showAlert] = useIonAlert();
        
    const fNameInputRef = useRef<any>();
    const emailInputRef = useRef<any>();
    const phoneInputRef = useRef<any>();
    const interestsInputRef = useRef<any>();
    const router = useIonRouter();

    const { authKey, authenticateMember, authorizedMember, getAuthorizedMember, updateMember, setLoading, level, levels, getLevels, limits, settings, getSettings, countries, states, setActivePartners, setAuthKey, setAuthorizedMember, setAvailableContacts, setAvailableKids, setAvailablePets, setCheckedContacts, setContacts, setEndPlaces, setKids, setPets, setPlaces, setRoutes, setPendingPartners, setSelectedVehiclesEnd, setSelectedVehiclesEnroute, setSelectedVehiclesStart, setStartPlaces, setVehicles, setVehiclesAll, setVehiclesEnd, setVehiclesEnroute, setVehiclesStart, setSettings, locationPerm, setLocationPerm, locationPermStr, setLocationPermStr, textLogoLoaded, fadeInTextLogo, SWTextLogo, SWFullHorizLogo, SWTextDarkLogo, showToast, nl2br } = useAppContext();
    
    useEffect(() => {
        if (authorizedMember) {
            // Strip the country code from memberPhone
            const phoneWithCountryCode = `${authorizedMember.memberPhone}`; 
            const countryCode = `${authorizedMember.memberPhoneCode}`;
            
            if(countryCode != 'undefined' && countryCode != '') {
                const phoneWithoutCountryCode = phoneWithCountryCode.replace(new RegExp('^\\' + countryCode), '');        
                setMemberPhone(phoneWithoutCountryCode);
            }
            //console.log('o');
            setFormValues({
                memberFirstName: authorizedMember.memberFirstName || "",
                memberLastName: authorizedMember.memberLastName || "",
                memberEmail: authorizedMember.memberEmail || "",
                memberPhone: memberPhone || "",
            });
        }
    }, [authorizedMember, memberPhone]);

    const toggleNameForm = () => setNameEdit(!nameEdit);
    const toggleEmailForm = () => setEmailEdit(!emailEdit);
    const togglePhoneForm = () => setPhoneEdit(!phoneEdit);
    const toggleAddressForm = () => setAddressEdit(!addressEdit);
    const toggleInterestsForm = () => setInterestsEdit(!interestsEdit);


    // Generic input value change handler
    const handleInputChange = (e: any) => {
        console.log(e);
        const { name, value } = e.target;
        console.log(name, value);
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };


    const validateEmail = async (e: any) => {
        //console.log(e);
        e.preventDefault();
        let email = emailInputRef.current.value;
        const valid = (email.length >= 6 &&
                       email.includes('@') === true &&
                       email.includes('.') === true &&
                       (email.match(/@/g)).length == 1 &&
                       email.indexOf('@') < email.lastIndexOf('.'));
            
        console.log(valid);

         if (valid) {
            showAlert({
                header: 'WARNING!',
                message: 'If you change your email address, you will be logged-out of your account, and your account will be de-activated until you re-verify the new email address. A verification email with further instructions will be sent to the new email address: ' + email,
                buttons: [
                    { 
                    text: 'Cancel', 
                    role: 'cancel',
                    cssClass: 'alert-button-cancel'
                    },
                    {
                        text: 'OK',
                        role: 'confirm',
                        cssClass: 'alert-button-confirm',
                        handler: async () => {
                            await updateMember(e);
                            const auth = await getAuthorizedMember(authorizedMember.memberToken); 
                            console.log(auth);
                            if (!auth) memberLogOut();
                        }
                    }
                ]
            }) 
         } else {
            showToast({
                message: 'Invalid email address.',
                duration: 2500,
                color: 'danger',
            });
        }
        //emailInputRef.current.value = authorizedMember.memberEmail;
    };

    const formatPhone = () => {
        const refVal = phoneInputRef.current.value;
        const formattedValue = refVal.replace(/\D/g,'');
        phoneInputRef.current.value = formattedValue; 
    };    


    //
    // Member Log-out
    //
    const memberLogOut = async () => {       
        await present('Logging out...');
        try {
            const formData = new FormData();
            formData.append('mt', authorizedMember.memberToken);
            const response = await fetch('https://api.besolowise.com/members/authenticate/signout/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                setLoading(true);
                const obj = await response.json();
                await Preferences.remove({key: 'solowise'});   
                setAuthKey({});
                setActivePartners({});
                setAuthorizedMember({});
                setAvailableContacts({});
                setAvailableKids({});
                setAvailablePets({});
                setCheckedContacts({});
                setContacts({});
                setKids({});
                setPendingPartners({});
                setPets({});
                setPlaces({});
                setRoutes({});
                setSelectedVehiclesEnd({});
                setSelectedVehiclesEnroute({});
                setSelectedVehiclesStart({});
                setSettings({});
                setStartPlaces({});
                setVehicles({});
                setVehiclesAll({});
                setVehiclesEnd({});
                setVehiclesEnroute({});
                setVehiclesStart({});
                document.body.classList.add('dark');
                setTimeout(async () => {
                    dismiss();
                    router.push('/', 'forward');
                }, 2000);                                
            } else {
                dismiss();
                showToast({
                    message: 'Log-out Error',
                    duration: 2000,
                    color: 'warning',
                    position: 'middle'
                });
            }
        } catch(error) {
            dismiss();
            showToast({
                message: 'Log-out Error: ' + error,
                duration: 2000,
                color: 'warning',
                position: 'middle'
            });
        }                     
    };

    
    return (
        <>
            <IonItem slot='header'>
                <IonLabel>My Contact Info</IonLabel>
            </IonItem>
            <div slot="content">                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleNameForm}><b>Name</b> <em className='required'>Required</em></IonLabel>
                        { nameEdit 
                            ? (<form name='nameForm' onSubmit={updateMember}>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol size='6'>
                                                <IonInput 
                                                    fill='outline' 
                                                    name='memberFirstName' 
                                                    placeholder='First name' 
                                                    type='text'                                                    
                                                    value={formValues.memberFirstName}>
                                                </IonInput>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <IonInput 
                                                    fill='outline' 
                                                    name='memberLastName' 
                                                    placeholder='Last name' 
                                                    type='text' 
                                                    value={formValues.memberLastName}>
                                                </IonInput>
                                            </IonCol>                                   
                                        </IonRow>
                                    </IonGrid>
                                    <IonButton className='ion-margin-top' color={'medium'} id='nameFormCancel' onClick={toggleNameForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='nameFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<p onClick={toggleNameForm}>                                    
                                    {authorizedMember.memberFirstName == '' && authorizedMember.memberLastName == ''
                                            ? (<>Not Recorded</>)
                                            : (<>{authorizedMember.memberFirstName} {authorizedMember.memberLastName}</>)
                                        }
                               </p>)
                        }
                    </IonCardContent>
                </IonCard>

                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleEmailForm}><b>Email</b> <em className='required'>Required</em></IonLabel>
                        { emailEdit  
                            ? (<form name='emailForm' onSubmit={validateEmail}> 
                                    <IonInput 
                                        fill='outline' 
                                        name='memberEmail' 
                                        ref={emailInputRef}
                                        type='email' 
                                        value={formValues.memberEmail}>
                                    </IonInput>
                                    <IonButton className='ion-margin-top' color={'medium'} id='emailFormCancel' onClick={toggleEmailForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='emailFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<>
                                <p onClick={toggleEmailForm}>{authorizedMember.memberEmail}</p>
                                </>) 
                        }                    
                    </IonCardContent>
                </IonCard>                
                
                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={togglePhoneForm}><b>Mobile Phone</b></IonLabel>
                        { phoneEdit  
                            ? (<form name='phoneForm' onSubmit={updateMember}>
                                    <IonSelect fill='outline' label='Country Code' labelPlacement='stacked' name='memberPhoneCode' placeholder='' value={authorizedMember.memberPhoneCode != '' ? authorizedMember.memberPhoneCode : '+1'} style={{ display: 'block', marginTop: '10px' }}>
                                        <IonSelectOption value='+1'>+1 (U.S. and Canada)</IonSelectOption>
                                        {countries.map((country:any, index:any) => (
                                            <IonSelectOption key={index} value={country['dial_code']}>{country['dial_code']} ({country['countries_name']})</IonSelectOption>
                                        ))}
                                    </IonSelect>
                                    <IonInput 
                                        className='ion-margin-bottom ion-margin-top' 
                                        fill='outline' 
                                        label='Phone Number' 
                                        labelPlacement='stacked' 
                                        name='memberPhone' 
                                        onKeyUp={formatPhone} 
                                        placeholder='' 
                                        ref={phoneInputRef} 
                                        type='tel' 
                                        value={memberPhone === undefined ? '' : memberPhone}>
                                    </IonInput>

                                    <p><IonText color={'dark'}>If you would like to use this number to receive text messages from SoloWise, for the sole purpose of reminding you to check-in for a Timer, you must opt-in under <Link to={'/account/preferences'}><IonText color={'secondary'}>My Settings</IonText></Link>.</IonText></p>
                                    <IonButton className='ion-margin-top' color={'medium'} id='phoneFormCancel' onClick={togglePhoneForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='phoneFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<>
                                <p onClick={togglePhoneForm}>
                                {authorizedMember.memberPhone == '' ? (<>Not Recorded</>) : (<>{authorizedMember.memberPhone}</>)}
                                </p>
                                </>) 
                        }                    
                    </IonCardContent>
                </IonCard>                
                
                <IonCard>
                    <IonCardContent> 
                        <IonLabel color={'dark'} onClick={toggleAddressForm}><b>Residence Address</b></IonLabel>                                   
                        { addressEdit  
                            ? (<form name='addressForm' onSubmit={updateMember}>
                                    <IonTextarea
                                        fill='outline' 
                                        name='memberAddress' 
                                        value={authorizedMember.memberAddress}>
                                    </IonTextarea>
                                    
                                    <IonButton className='ion-margin-top' color={'medium'} id='addressFormCancel' onClick={toggleAddressForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='addressFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<>
                                <div onClick={toggleAddressForm}>
                                    {authorizedMember.memberAddress == '' 
                                        ? (<p>Not Recorded</p>) 
                                        : (<>
                                            <p><span dangerouslySetInnerHTML={{ __html: nl2br(authorizedMember.memberAddress) }} /></p>
                                            </>)
                                    } 
                                </div>
                                </>) 
                        }                      
                    </IonCardContent>
                </IonCard>

                <IonCard>
                    <IonCardContent>
                        <IonLabel color={'dark'} onClick={toggleInterestsForm}><b>Garmin InReach</b></IonLabel>
                        { interestsEdit  
                            ? (<form name='interestsForm' onSubmit={updateMember}> 
                                    <IonInput 
                                        fill='outline' 
                                        name='memberInterests' 
                                        ref={interestsInputRef}
                                        type='tel' 
                                        value={authorizedMember.memberInterests === undefined ? '' : authorizedMember.memberInterests}>
                                    </IonInput>
                                    <IonButton className='ion-margin-top' color={'medium'} id='interestsFormCancel' onClick={toggleInterestsForm}>Cancel</IonButton>
                                    <IonButton className='ion-margin-top' color={'secondary'} id='interestsFormSubmit' type='submit'>Save</IonButton>
                                </form>)                                                     
                            : (<>
                               <p onClick={toggleInterestsForm}>
                                {authorizedMember.memberInterests == '' ? <>Not Recorded</> : <>{authorizedMember.memberInterests}</>}
                                </p>
                                </>) 
                        }                    
                    </IonCardContent>
                </IonCard>                                            
            </div>
        </>
    );
};

export default AccountContact;